export default __webpack_public_path__ + "static/media/me.367e782e.jpg";